<template>
  <a-config-provider :locale="pl_PL">
    <div class="offer-config-wrapper">
      <form onSubmit="return false" class="offer-config">
        <div v-if="searcherLoading" class="loader-layer">
          <a-spin>
            <a-icon
              slot="indicator"
              type="loading"
              style="font-size: 32px"
              spin
            />
          </a-spin>
        </div>

        <div v-show="!validoffer" class="offer-config__unavailable">
          <span class="svg-icon mr-10" aria-hidden="true">
            <svg class="svg-icon__svg" width="18" height="18" focusable="false">
              <slot name="icon">
                <use xlink:href="/img/static/svg-sprites.svg#icon-delete"></use>
              </slot>
            </svg>
          </span>
          <span> Oferta niedostępna dla wybranej konfiguracji. </span>
        </div>

        <div v-show="validoffer" class="offer-config__header">
          <a-row
            :gutter="10"
            type="flex"
            align="bottom"
            justify="end"
            v-show="discount > 5 && discount < 70"
          >
            <a-col>
              <div class="price-discount">
                <span class="price-discount__old">{{ maxprice }} PLN</span>
                <span class="price-discount__badge">-{{ discount }}%</span>
              </div>
            </a-col>
          </a-row>
          <div v-show="price" class="offer-config__price">
            <span>Cena za 1 osobę:</span>
            <span>
              <span class="font-22"
                >{{ price }} <span class="font-18">PLN</span></span
              >
            </span>
          </div>
          <!-- <span v-show="!validoffer" class="offer-status">Oferta jest niedostępna!</span> -->
          <!-- <span v-show="validoffer" class="offer-status available">Oferta jest dostępna!</span> -->
          <!-- <span v-show="validoffer" class="font-14"> -->

          <!-- kod oferty: {{ naszKod }} -->
          <!-- <span id="akt_tourOp">{{ tourOp }}</span>-<span id="akt_htlCode">{{ htlCode }}</span> -->
          <!-- </span> -->
        </div>

        <div class="offer-config__fieldset">
          <a-row :gutter="10">
            <a-col :span="12">
              <div class="offer-config__cell">
                <span class="label">Dorośli</span>
                <div class="selector">
                  <a-select
                    v-model="adtVal"
                    :defaultValue="[]"
                    @change="handleChangeAdt"
                  >
                    <a-select-option
                      v-for="n in 10"
                      :id="n"
                      :key="n"
                      :selected="adtVal.includes(n)"
                    >
                      {{ n }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="offer-config__cell">
                <span class="label">Dzieci</span>
                <div class="selector">
                  <a-select
                    v-model="chdVal"
                    :defaultValue="[]"
                    @change="handleChangeChd"
                  >
                    <a-select-option
                      v-for="n in 5"
                      :key="n - 1"
                      :selected="chdVal.includes(n - 1)"
                    >
                      {{ n - 1 }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </a-col>
          </a-row>

          <a-row v-show="chd > 0">
            <div class="offer-config__cell">
              <span class="label">Wiek dzieci</span>

              <a-row :gutter="10">
                <a-col :span="6" v-show="chd > 0">
                  <div class="selector">
                    <a-select
                      name="c1"
                      v-model="chd1Val"
                      :defaultValue="[]"
                      @change="handleChangeChd1"
                    >
                      <a-select-option
                        v-for="n in 16"
                        :key="n"
                        :selected="chd1Val.includes(n)"
                      >
                        {{ n }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-col>

                <a-col :span="6" v-show="chd > 1">
                  <div class="selector">
                    <a-select
                      name="c2"
                      v-model="chd2Val"
                      @change="handleChangeChd2"
                    >
                      <a-select-option
                        v-for="n in 16"
                        :key="n"
                        :selected="chd2Val.includes(n)"
                      >
                        {{ n }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-col>

                <a-col :span="6" v-show="chd > 2">
                  <div class="selector">
                    <a-select
                      name="c3"
                      v-model="chd3Val"
                      @change="handleChangeChd3"
                    >
                      <a-select-option
                        v-for="n in 16"
                        :key="n"
                        :selected="chd3Val.includes(n)"
                      >
                        {{ n }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-col>

                <a-col :span="6" v-show="chd > 3">
                  <div class="selector">
                    <a-select
                      name="c4"
                      v-model="chd4Val"
                      @change="handleChangeChd4"
                    >
                      <a-select-option
                        v-for="n in 16"
                        :key="n"
                        :selected="chd4Val.includes(n)"
                      >
                        {{ n }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-row>

          <a-row :gutter="10">
            <a-col>
              <div class="offer-config__cell">
                <span class="label d-flex f-sb"
                  >Terminy
                  <span
                    class="offer-config__reset"
                    title="Zresetuj"
                    @click="handleAllDates()"
                  >
                    <span class="svg-icon" aria-hidden="true">
                      <svg
                        class="svg-icon__svg"
                        width="12"
                        height="12"
                        focusable="false"
                      >
                        <use
                          xlink:href="/img/static/svg-sprites.svg#icon-undo"
                        ></use>
                      </svg>
                    </span>
                  </span>
                </span>

                <div class="selector">
                  <a-select
                    v-model="startDateVal"
                    :defaultValue="[]"
                    @change="handleChangeTermin"
                  >
                    <a-select-option
                      v-for="item in getFiltryItems('trp_depDate')"
                      :id="item.id"
                      :key="formatData(item.id)"
                      :selected="startDateVal.includes(formatData(item.id))"
                    >
                      {{ formatData(item.id) }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </a-col>
          </a-row>

          <a-row :gutter="10">
            <a-col :span="12">
              <div class="offer-config__cell">
                <span class="label d-flex f-sb"
                  >Długość pobytu
                  <span
                    class="offer-config__reset"
                    title="Zresetuj"
                    @click="handleAllDlugosci()"
                  >
                    <span class="svg-icon" aria-hidden="true">
                      <svg
                        class="svg-icon__svg"
                        width="12"
                        height="12"
                        focusable="false"
                      >
                        <use
                          xlink:href="/img/static/svg-sprites.svg#icon-undo"
                        ></use>
                      </svg>
                    </span>
                  </span>
                </span>
                <div class="selector">
                  <a-select
                    v-model="durationVal"
                    :defaultValue="[]"
                    @change="handleChangePobyt"
                  >
                    <a-select-option
                      v-for="item in getFiltryItems('trp_durationM')"
                      :id="item.id"
                      :key="item.id"
                      :selected="durationVal.includes(item.id)"
                    >
                      {{ item.id }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="offer-config__cell">
                <span class="label d-flex f-sb"
                  >Wyjazd z
                  <span
                    class="offer-config__reset"
                    title="Zresetuj"
                    @click="handleAllWyjazds()"
                  >
                    <span class="svg-icon" aria-hidden="true">
                      <svg
                        class="svg-icon__svg"
                        width="12"
                        height="12"
                        focusable="false"
                      >
                        <use
                          xlink:href="/img/static/svg-sprites.svg#icon-undo"
                        ></use>
                      </svg>
                    </span>
                  </span>
                </span>
                <div class="selector">
                  <a-select
                    v-model="depNameVal"
                    :defaultValue="[0]"
                    @change="handleChangeWyjazd"
                  >
                    <a-select-option
                      v-for="item in getFiltryItems('trp_depName')"
                      :id="item.id"
                      :key="item.id"
                      :selected="depNameVal.includes(item.id)"
                    >
                      {{ item.id }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </a-col>
          </a-row>

          <a-row :gutter="10">
            <a-col>
              <div class="offer-config__cell">
                <span class="label d-flex f-sb"
                  >Typ dojazdu
                  <span
                    class="offer-config__reset"
                    title="Zresetuj długość pobytu"
                    @click="handleAllDojazds()"
                  >
                    <span class="svg-icon" aria-hidden="true">
                      <svg
                        class="svg-icon__svg"
                        width="12"
                        height="12"
                        focusable="false"
                      >
                        <use
                          xlink:href="/img/static/svg-sprites.svg#icon-undo"
                        ></use>
                      </svg>
                    </span>
                  </span>
                </span>

                <div class="selector">
                  <a-select
                    v-model="ofr_typeVal"
                    :defaultValue="[]"
                    @change="handleChangeTypWyjazdu"
                  >
                    <a-select-option
                      v-for="item in getFiltryItems('ofr_type')"
                      :id="item.id"
                      :key="getDojazd(item.id, true)"
                      :selected="
                        ofr_typeVal.includes(getDojazd(item.id, false))
                      "
                    >
                      {{ getDojazd(item.id, false) }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </a-col>
          </a-row>

          <a-row :gutter="10">
            <a-col>
              <div class="offer-config__cell">
                <span class="label">Wyżywienie</span>
                <div class="selector">
                  <a-select
                    v-model="xServiceIdVal"
                    :defaultValue="[]"
                    @change="handleChangeWyzyw"
                  >
                    <a-select-option
                      v-for="item in getFiltryItems('obj_xServiceId')"
                      :key="getWyzywienie(item.id)"
                      :selected="xServiceIdVal.includes(getWyzywienie(item.id))"
                    >
                      {{ getWyzywienie(item.id) }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </a-col>
            <a-col>
              <div class="offer-config__cell">
                <span class="label">Organizator</span>
                <div class="selector">
                  <a-select v-model="tourOpVal" :defaultValue="[]">
                    <a-select-option
                      v-for="item in getFiltryItems('ofr_tourOp')"
                      :id="item.id"
                      :key="item.id"
                      :selected="tourOpVal.includes(item.id)"
                    >
                      {{ getTouropName(item.id, false) }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>

        <div v-show="validoffer" class="offer-config__footer">
          <div class="offer-config__summary">
            <div v-if="priceLoading" class="loader-layer">
              <a-spin>
                <a-icon
                  slot="indicator"
                  type="loading"
                  style="font-size: 24px"
                  spin
                />
              </a-spin>
            </div>

            <div v-show="pricedetails" class="offer-config__price-parts">
              <div v-for="(person, key, index) in arrAPersons" :key="index">
                <a-row :gutter="10" type="flex" justify="space-between">
                  <a-col>{{ person.counter }} x {{ getHashString(key) }}</a-col>
                  <a-col
                    >{{ person.counter }} x {{ person.price }}
                    {{ pricetotalCurr }}</a-col
                  >
                </a-row>
              </div>
            </div>

            <div class="offer-config__price">
              <span>Cena całkowita:</span>
              <span
                ><span class="font-20 total-price">{{ pricetotal }}</span></span
              >
            </div>
          </div>

          <div class="offer-config__order-button">
            <button
              @click="handleRezSubmit"
              class="btn btn-lg btn-green btn-block"
            >
              Zamówienie wstępne
            </button>
          </div>
        </div>

        <div id="hidden-div-offer" style="display: none">
          <span class="hidden_typ_zapytania" value="ZapytanieRezerwacja" />
          <span class="hidden_oferta" :value="kodId" />
          <span class="hidden_kodId" :value="kodId" />
          <span class="hidden_tourOp" :value="tourOp" />
          <span class="hidden_turnus" value="1" />
          <span class="hidden_htlCode" :value="htlCode" />
          <span class="hidden_htlCat" value="" />
          <span class="hidden_ileTW" value="0" />
          <span class="hidden_xcode" :value="xCode" />
          <span class="hidden_hotel" :value="ofrObjName" />
          <span class="hidden_data_od" :value="tstartDate" />
          <span class="hidden_data_do" :value="tendDate" />
          <span class="hidden_dojazd" :value="dojazd" />
          <span class="hidden_narty" value="" />
          <span class="hidden_miasto_wyjazdu" :value="depName" />
          <span class="hidden_cena" :value="price" />
          <span class="hidden_cenawyc" id="cenawyc" :value="pricetotal" />
          <span class="hidden_cenacalk" id="cenacalk" :value="pricetotal" />
          <span class="hidden_season" value="" />
          <span class="hidden_email2" value="" />
          <span class="hidden_fax" value="" />
          <span class="hidden_tel_kom" value="" />
          <span class="hidden_linf" :value="inf" />
          <span class="hidden_lchd" :value="chd" />
          <span class="hidden_ladt" :value="adt" />
          <span class="hidden_lchage" :value="chage" />
          <span class="hidden_linkbase" :value="getLinkBase()" />
          <span class="hidden_link" :value="getDirectLink()" />
          <span class="hidden_panstwoid" :value="getPanstwoId()" />
          <span class="hidden_plec" value="" />
          <span class="hidden_adres" value="" />
          <span class="hidden_kod" value="" />
          <span class="hidden_miasto" value="" />
          <span class="hidden_kraj" value="" />
          <span class="hidden_countryId" :value="countryId" />
          <span class="hidden_owyz" :value="xServiceIdVal" />
          <span class="hidden_opobyt" :value="durationVal" />
          <span class="hidden_okierunek" :value="kierunek" />
          <span class="hidden_ozakw" :value="zakwaterowanie" />
          <span class="hidden_otourop" :value="tourOp" />
        </div>
      </form>
    </div>
  </a-config-provider>
</template>

<script>
import T1VarLoader from "../T1VarLoader";
import { wyzywienie } from "../wyzywienie.js";
import axios from "axios";
import * as CONFIG from "../config.js";
import * as WYJAZD from "../wyjazd.js";
import pl_PL from "ant-design-vue/lib/locale-provider/pl_PL";
import moment from "moment";
import "moment/locale/pl";
moment.locale("pl");
var bigInt = require("big-integer");

axios.defaults.withCredentials = false;

export default {
  name: "offer-config-searcher",
  props: {
    category: String,
  },
  data: () => ({
    pl_PL,
    url: "/getdropdowns.json",
    urloferty: "/getdetails.json",
    urloptions: "/getofferoptions.json",
    urlprice: "/checkmdsprice.json",
    urltotprice: "/checkmdstotalprice.json",
    dparams: "dropdowns=1",
    dparamsoferty: "",
    dparamsoptions: "",
    dparamsprice: "",
    dparamspricetimeout: 5000,
    dparamstotprice: "x=1&totp=1",
    fdata: [],
    foptions: [],
    kodId: "",
    naszKod: "CI",
    tourOp: "",
    htlCode: "",
    wyzyw: wyzywienie.wyzwysz,
    wyzywval: wyzywienie.wyzvals,
    ftourops: [],
    tourOpVal: [],
    adtVal: [],
    chdVal: [],
    infVal: [],
    chageVal: "",
    chd1Val: [],
    chd2Val: [],
    chd3Val: [],
    chd4Val: [],
    adt: 0,
    chd: 0,
    inf: 0,
    chage: "",
    ofr_type: "",
    ofr_typeVal: [],
    minPax: 0,
    maxPax: 0,
    minAdt: 0,
    maxAdt: 0,
    xServiceId: 0,
    xServiceIdVal: [],
    startDate: "",
    startDateVal: [],
    tstartDate: "",
    tendDate: "",
    duration: 0,
    durationVal: [],
    depName: "",
    depNameVal: [],
    xCode: "",
    wyjazd: "",
    validoffer: true,
    pricetotal: "nieznana",
    pricetotalVal: -1,
    pricetotalCurr: "",
    arrPersons: [],
    arrAPersons: {},
    arrHashes: [],
    arrStrings: {},
    cherror: false,
    pricedetails: false,
    // hotel: "",
    ofrObjName: "",
    dojazd: "",
    price: "",
    maxprice: "",
    discount: "",
    countryId: -1,
    hattr: 0,
    hattrs: [],
    offerType: "",
    region: "",
    xcity: "",
    city: "",
    directlink: "",
    kierunek: "",
    zakwaterowanie: "",
    hlocid: "",
    fromDate: "",
    priceLoading: false,
    searcherLoading: true,
    firstGTM: false,
  }),
  methods: {
    getPanstwoId() {
      return "" + CONFIG.panstwo_id;
    },
    getLinkBase() {
      return "http://www." + CONFIG.serwis + "/merlinobiektmds-param.xml";
    },
    getSchowekPrefix() {
      return "https://www.travelone.pl/oferta/schowek.xml?oper=add&";
    },
    getUrlSchowka() {
      return this.urlschowka;
    },
    getDirectLink() {
      return decodeURIComponent(this.$route.path) + "?" + this.directlink;
    },
    getSchowekTitle() {
      return "Dodaj ofertę do schowka";
    },
    handleRezSubmit() {
      scrollToForm();
    },
    getWyzywienie(numer) {
      return this.wyzyw[numer - 1];
    },
    getWyzywienieVal(numer) {
      return this.wyzywval[numer - 1];
    },
    getOfferOptions() {
      var pars =
        this.dparamsoptions +
        "&date=" +
        this.formatData(this.startDate) +
        "&pobyt=" +
        this.duration;
      //console.log('URL:' + CONFIG.API_URL + this.urloptions + '?' + pars);
      return axios
        .get(CONFIG.API_URL + this.urloptions + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          console.log("ERROR 400");
        });
    },
    checkMdsTotalPrice() {
      var pars = this.dparamstotprice;
      return axios
        .get(CONFIG.API_URL + this.urltotprice + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          console.log("ERROR 300");
        });
    },
    checkMdsPrice() {
      var pars = this.dparamsprice;
      var tmout = this.dparamspricetimeout;
      return axios
        .get(
          CONFIG.API_URL + this.urlprice + "?" + pars,
          { timeout: tmout },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json",
            },
          }
        )
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          console.log("ERROR 100");
        });
    },
    getOfferDetails() {
      var pars = this.dparamsoferty;
      console.log("PARS:" + pars);
      return axios
        .get(
          CONFIG.API_URL + this.urloferty + "?" + pars,
          { timeout: 5000 },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json",
            },
          }
        )
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          console.log("ERROR 200");
        });
    },
    getDropdownItems() {
      var pars = this.dparams;
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
               alert("STATUS:" + response.status);
               alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getQueryParams(
      firstRun,
      omitTermin,
      omitWyjazd,
      omitPobyt,
      omitWyzyw,
      omitAdt,
      omitChd
    ) {
      //this.dparams =  'dropdowns=1';
      let lparams = this.$route.query;
      if (lparams["xCode"]) {
        let val = decodeURIComponent(lparams["xCode"]);
        this.xCode = val;
        if (this.dparams.indexOf("xCode") < 0) {
          this.dparams += "&xCode=" + val;
        }
      }
      if (lparams["tourOp"]) {
        let val = decodeURIComponent(lparams["tourOp"]);
        if (this.dparams.indexOf("tourOp") < 0) {
          this.dparams += "&tourOp=" + val;
        }
        this.tourOp = val;
        this.tourOpVal = [];
        this.tourOpVal.push(val);
      }
      if (lparams["htlCode"]) {
        let val = decodeURIComponent(lparams["htlCode"]);
        this.htlCode = val;
        if (this.dparams.indexOf("htlCode") < 0) {
          this.dparams += "&htlCode=" + val;
        }
        this.htlCode = val;
      }
      if (!omitWyjazd && lparams["wyj"]) {
        let val = decodeURIComponent(lparams["wyj"]);
        this.wyjazd = val;
        this.dparams += "&wyj=" + val;
      }
      if (firstRun && !omitAdt && lparams["adt"]) {
        let val = decodeURIComponent(lparams["adt"]);
        this.dparams += "&adt=" + val;
        this.adt = Number(val);
        this.adtVal = [];
        this.adtVal.push(Number(val));
      } else if (firstRun && !omitAdt) {
        this.dparams += "&adt=" + 2;
        this.adt = Number(2);
        this.adtVal = [];
        this.adtVal.push(Number(2));
      }
      if (!omitChd && lparams["chd"]) {
        let val = decodeURIComponent(lparams["chd"]);
        this.dparams += "&chd=" + val;
        this.chd = Number(val);
        this.chdVal = [];
        this.chdVal.push(Number(val));
      }
      if (lparams["inf"]) {
        let val = decodeURIComponent(lparams["inf"]);
        //this.dparams += "&inf=" + val;
        this.inf = Number(val);
        this.infVal = [];
        this.infVal.push(Number(val));
        if (firstRun || !omitChd) {
          this.chd += this.inf;
          this.chdVal = [];
          this.chdVal.push(this.chd);
        }
      }
      if (lparams["chage"] || this.inf > 0) {
        let val = decodeURIComponent(lparams["chage"]);
        //this.dparams += "&chage=" + val;
        if (lparams["chage"]) {
          this.chage = val;
        } else {
          this.chage = "";
        }
        if (this.inf > 0) {
          for (var i = 0; i < this.inf; i++) {
            if (i == 0) {
              if (this.chage !== "") {
                val += ",1";
              } else {
                val = "1";
              }
            } else {
              val += ",1";
            }
          }
        }
        this.setChageParams(val);
      }
      this.dparamsoptions += this.dparams.substring(12);
      if (firstRun && lparams["kodId"]) {
        let val = decodeURIComponent(lparams["kodId"]);
        this.dparams += "&kodId=" + val;
        this.kodId = val;
      }
      if (firstRun) {
        this.dparamsoferty = "kodId=" + this.kodId;
      }
      this.setPriceParams();
      this.dparamstotprice = "x=1&totp=1&" + this.dparamsprice;
      console.log("DPARAMS:" + this.dparams);
    },
    setChageParams(value) {
      let chageps = [];
      if (value != null) {
        chageps = value.split(",");
        for (var i = 0; i < chageps.length; i++) {
          if (i == 0) {
            this.chd1Val = [];
            this.chd1Val.push(chageps[0]);
          }
          if (i == 1) {
            this.chd2Val = [];
            this.chd2Val.push(chageps[1]);
          }
          if (i == 2) {
            this.chd3Val = [];
            this.chd3Val.push(chageps[2]);
          }
          if (i == 3) {
            this.chd4Val = [];
            this.chd4Val.push(chageps[3]);
          }
        }
      }
    },
    updateOffers(i) {},
    getFiltryItems(typ) {
      if (this.fdata.length > 0) {
        var bb = this.fdata.filter(function (value, index) {
          return value.id == typ;
        });
        var t = bb[0].f;
        if (t instanceof Array) {
          if (t[0].id instanceof Array) {
            bb[0].f[0].id = "dowolny";
            bb[0].f[0].gCnt = "dowolny";
          }
          return bb[0].f;
        } else {
          let x = [];
          if (bb[0].f.id instanceof Array) {
            bb[0].f.id = "dowolny";
            bb[0].f.gCnt = "dowolny";
          }
          x.push(bb[0].f);
          return x;
        }
      } else {
        return [];
      }
    },
    formatData(data) {
      if (data != "" && data.length >= 8) {
        return (
          data.substring(0, 4) +
          "-" +
          data.substring(4, 6) +
          "-" +
          data.substring(6)
        );
      } else {
        return "";
      }
    },
    getFromDate(data) {
      if (data != "" && data.length >= 8) {
        return data.substring(4, 6) + data.substring(6);
      } else {
        return "";
      }
    },
    getTouropName(kod, naszkod) {
      var aa = this.ftourops.filter(function (value, index) {
        return value.kod == kod;
      });
      if (aa != null && aa.length > 0) {
        if (naszkod) {
          return aa[0].naszid;
        } else {
          return aa[0].nazwa;
        }
      }
    },
    getDojazd(kod, naszkod) {
      if (kod == "F" || kod == "NF") return "samolot";
      else if (kod == "BU" || kod == "NB") return "autokar";
      else if (kod == "H") return naszkod ? "wlasny" : "własny";
      else return "nieznany";
    },
    getWyjKod(val) {
      if (val == "dowolny") return "F,H,BU";
      else if (val == "samolot") return "F";
      else if (val == "autokar") return "BU";
      else if (val == "wlasny") return "H";
      else return "F,H,BU";
    },
    getDiscount(x, y) {
      return 100 - (x * 100) / y;
    },
    calculateChage() {
      let chage = "";
      let inf = 0;
      let chd = this.chd;
      if (this.chd > 0) {
        if (this.chd1Val.length > 0) {
          let val = this.chd1Val;
          if (val == "2-" || val == "1") {
            inf++;
          } else if (val == "") {
            chage += "3,";
          } else {
            chage += val + ",";
          }
        } else {
          chage += "3,";
        }
        if (this.chd > 1) {
          if (this.chd2Val.length > 0) {
            let val = this.chd2Val;
            if (val == "2-" || val == "1") {
              inf++;
            } else if (val == "") {
              chage += "3,";
            } else {
              chage += val + ",";
            }
          } else {
            chage += "3,";
          }
          if (this.chd > 2) {
            if (this.chd3Val.length > 0) {
              let val = this.chd3Val;
              if (val == "2-" || val == "1") {
                inf++;
              } else if (val == "") {
                chage += "3,";
              } else {
                chage += val + ",";
              }
            } else {
              chage += "3,";
            }
            if (this.chd > 3) {
              if (this.chd4Val.length > 0) {
                let val = this.chd4Val;
                if (val == "2-" || val == "1") {
                  inf++;
                } else if (val == "") {
                  chage += "3,";
                } else {
                  chage += val + ",";
                }
              } else {
                chage += "3,";
              }
            }
          }
        }
      }
      if (chage.length > 0) {
        chage = chage.substring(0, chage.length - 1);
      }
      if (inf > 0) {
        chd = chd - inf;
      }
      let children = "chd=" + chd + "&chage=" + chage;
      if (inf > 0) {
        children += "&inf=" + inf;
      }
      this.chage = chage;
      //this.chd = Number(chd);
      //this.inf = Number(inf);
      //console.log("CHILDREN:" + children);
      return children;
    },
    handleChangeTypWyjazdu(val, id) {
      this.dojazd = val;
      this.ofr_type = this.getWyjKod(val);
      this.ofr_typeVal = [];
      this.ofr_typeVal.push(val);
      this.handleURLChange("dojazd", val);
    },
    handleChangeAdt(val, id) {
      this.adtVal = [val];
      this.adt = Number(val);
      this.handleURLChange("adt", val);
    },
    handleChangeChd(val, id) {
      this.chd = Number(val);
      this.chdVal = [val];
      let childrenVal = this.calculateChage();
      this.handleURLChange("children", childrenVal);
    },
    handleChangeChd1(val, id) {
      this.chd1Val = [];
      this.chd1Val.push(Number(val));
      let childrenVal = this.calculateChage();
      this.handleURLChange("children", childrenVal);
    },
    handleChangeChd2(val, id) {
      this.chd2Val = [];
      this.chd2Val.push(Number(val));
      let childrenVal = this.calculateChage();
      this.handleURLChange("children", childrenVal);
    },
    handleChangeChd3(val, id) {
      this.chd3Val = [];
      this.chd3Val.push(Number(val));
      let childrenVal = this.calculateChage();
      this.handleURLChange("children", childrenVal);
    },
    handleChangeChd4(val, id) {
      this.chd4Val = [];
      this.chd4Val.push(Number(val));
      let childrenVal = this.calculateChage();
      this.handleURLChange("children", childrenVal);
    },
    handleChangeTermin(val, id) {
      this.startDate = val.replace(/-/g, "");
      this.handleURLChange("termin", val);
    },
    handleAllDates() {
      this.handleURLChange("resetDates", 1);
    },
    handleAllWyjazds() {
      this.handleURLChange("resetWyjazds", 1);
    },
    handleAllDlugosci() {
      this.handleURLChange("resetDlugosci", 1);
    },
    handleAllDojazds() {
      this.handleURLChange("resetDojazds", 1);
    },
    handleChangeWyjazd(val, id) {
      // TODO - full replace
      this.depName = WYJAZD.wyjazdToLower(val);
      this.handleURLChange("wyjazd", this.depName);
    },
    handleChangePobyt(val, id) {
      this.duration = val;
      this.handleURLChange("pobyt", val);
    },
    handleChangeWyzyw(val, id) {
      let index = this.wyzyw.indexOf(val);
      this.xServiceId = "" + (index + 1);
      try {
        this.handleURLChange("wyzyw", this.getWyzywienieVal(index + 1));
      } catch (error) {
        console.log("ERROR:" + error);
      }
    },
    getChildrenParameter(paramName, value) {
      var searchString = value,
        i,
        val,
        params = searchString.split("&");
      for (i = 0; i < params.length; ++i) {
        val = params[i].split("=");
        if (val[0] == paramName) {
          return unescape(val[1]);
        }
      }
      return undefined;
    },
    addParamsToLocation(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
          "?" +
          Object.keys(params)
            .map((key) => {
              return (
                encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
              );
            })
            .join("&")
      );
    },
    handleURLChange(name, value) {
      this.priceLoading = true;
      // this.pricetotal = " ... wyliczam ...";
      this.pricedetails = false;
      let query = this.$route.query;
      let path = this.$route.path;
      if (name === "children") {
        let chd = this.getChildrenParameter("chd", value);
        if (chd !== undefined) {
          query["chd"] = chd;
        }
        let chage = this.getChildrenParameter("chage", value);
        if (chage !== undefined) {
          query["chage"] = chage;
        }
        let inf = this.getChildrenParameter("inf", value);
        //if (inf !== undefined) {
        query["inf"] = inf;
        //}
      }

      let xCode = "";
      if (query["xCode"]) {
        // console.log("QUERY xCODE:" + query["xCode"]);
        xCode = query["xCode"];
      } else {
        // console.log("THIS xCODE:" + this.xCode);
        xCode = this.xCode;
      }
      let tourOp = "";
      if (query["tourOp"]) {
        tourOp = query["tourOp"];
      } else {
        tourOp = this.tourOp;
      }
      let htlCode = "";
      if (query["htlCode"]) {
        htlCode = query["htlCode"];
      } else {
        htlCode = this.htlCode;
      }
      let fromDate = "";
      if (query["fromDate"]) {
        fromDate = query["fromDate"];
      }

      let termin = name === "termin" ? value : query["termin"];
      let wyjazd = name === "wyjazd" ? value : query["wyjazd"];
      let pobyt = name === "pobyt" ? value : query["pobyt"];
      let wyz = name === "wyz" ? value : query["wyz"];
      let adt = name === "adt" ? value : query["adt"];
      let chd = name === "chd" ? value : query["chd"];
      let inf = name === "inf" ? value : query["inf"];
      let chage = name === "chage" ? value : query["chage"];
      let dojazd = name === "dojazd" ? value : query["dojazd"];
      //let queryparams = { xCode: query['xCode'], tourOp: query['tourOp'], htlCode: query['htlCode'], fromDate: query['fromDate'] };
      let queryparams = { xCode: xCode, tourOp: tourOp, htlCode: htlCode };

      if (dojazd === undefined) {
        dojazd = this.dojazd;
      }
      Object.assign(queryparams, { dojazd: dojazd });

      if (termin === undefined) {
        termin = this.formatData(this.startDate);
      }
      Object.assign(queryparams, { termin: termin });

      if (wyjazd === undefined) {
        wyjazd = WYJAZD.wyjazdToLower(this.depName);
      }
      Object.assign(queryparams, { wyjazd: wyjazd });

      if (pobyt === undefined) {
        pobyt = this.duration;
      }
      Object.assign(queryparams, { pobyt: pobyt });

      if (wyz === undefined) {
        wyz = this.getWyzywienieVal(Number(this.xServiceId));
      }
      Object.assign(queryparams, { wyz: wyz });

      this.calculateChage();

      if (adt === undefined) {
        adt = this.adt;
      }
      Object.assign(queryparams, { adt: adt });

      if (chd === undefined) {
        chd = this.chd;
      }
      Object.assign(queryparams, { chd: chd });

      //console.log("INFFFFFFF:" + inf);
      if (inf === undefined) {
        //inf = this.inf;
      } else {
        Object.assign(queryparams, { inf: inf });
      }

      if (chage === undefined) {
        chage = this.chage;
      }
      Object.assign(queryparams, { chage: chage });

      this.addParamsToLocation(queryparams);
      this.dparams = "dropdowns=1";
      this.dparamsoferty = "xCode=" + this.xCode;
      this.dparamsoferty += "&tourOp=" + this.tourOp;
      this.dparamsoferty += "&htlCode=" + this.htlCode;

      this.dparams += "&" + this.dparamsoferty;
      this.dparamsoferty += "&termin=" + this.formatData(this.startDate);
      if (name == "resetDates") {
        // console.log("Reloading with all Dates");
      } else {
        this.dparams += "&data=" + this.formatData(this.startDate);
      }
      this.dparamsoferty += "&date=" + this.formatData(this.startDate);

      if (name == "resetDlugosci") {
        // console.log("Reloading with all Dlugosci Pobytu");
      } else {
        this.dparams += "&pobyt=" + this.duration;
      }
      this.dparamsoferty += "&pobyt=" + this.duration;

      // TODO -- add full text replace
      if (this.depName != null && this.depName != "dowolny") {
        if (name == "resetDojazds") {
        } else if (this.ofr_type != "H") {
          this.dparamsoferty += "&wyjazd=" + WYJAZD.wyjazdToLower(this.depName);
        }
        if (
          name == "resetWyjazds" ||
          name == "resetDojazds" ||
          this.dojazd == "wlasny"
        ) {
          // console.log("Reloading with all locations");
        } else {
          this.dparams += "&wyjazd=" + WYJAZD.wyjazdToLower(this.depName);
        }
      }
      this.dparamsoferty +=
        "&wyz=" + this.getWyzywienieVal(Number(this.xServiceId));
      this.dparamsoferty += "&adt=" + this.adt;
      if (this.chd > 0) {
        //this.dparamsoferty += '&chd=' + this.chd;
        //this.dparamsoferty += '&chage=' + this.chage;
        this.dparamsoferty += "&" + this.calculateChage();
      }
      if (
        this.ofr_type != null &&
        (this.ofr_type != "dowolny" || this.ofr_type != "F,H,BU")
      ) {
        this.dparamsoferty += "&wyj=" + this.ofr_type;
        if (name == "resetDojazds") {
          // console.log("Reloading with all dojazd");
        } else if (name != "resetDates") {
          this.dparams += "&wyj=" + this.ofr_type;
        }
      }
      this.dparamsoptions = "";

      this.setPriceParams();
      this.dparamstotprice = "x=1&totp=1&" + this.dparamsprice;

      let omitTermin = name === "termin" ? true : false;
      let omitWyjazd = name === "wyjazd" ? true : false;
      let omitPobyt = name === "pobyt" ? true : false;
      let omitWyzyw = name === "wyzyw" ? true : false;
      let omitAdt = name === "adt" ? true : false;
      let omitChd = name === "children" ? true : false;

      this.reloadData(
        false,
        omitTermin,
        omitWyjazd,
        omitPobyt,
        omitWyzyw,
        omitAdt,
        omitChd,
        false
      );
    },
    setPriceParams() {
      this.dparamsprice = "kodId=" + this.kodId;
      this.dparamsprice += "&parAdt=" + this.adt;
      this.dparamsprice += "&tourOp=" + this.tourOp;
      let adtAge = "";
      for (let i = 0; i < this.adt; i++) {
        adtAge += "19800101,";
      }
      this.dparamsprice += "&adta=" + adtAge.substring(0, adtAge.length - 1);
      this.calculateChage();
      let chno = this.chd;
      if (chno > 0) {
        let chdages = "";
        let infages = "";
        let aktDate = this.formatData(this.startDate);
        let tempDate = "";
        if (this.chd1Val != "") {
          tempDate = Number(aktDate.substring(0, 4)) - Number(this.chd1Val);
        } else {
          tempDate = Number(aktDate.substring(0, 4)) - Number(3);
        }
        if (this.chd1Val != "" && this.chd1Val < 2) {
          infages += tempDate + aktDate.substring(4).replace(/-/g, "");
          infages += ",";
        } else {
          chdages += tempDate + aktDate.substring(4).replace(/-/g, "");
          chdages += ",";
        }
        if (chno > 1) {
          if (this.chd2Val != "") {
            tempDate = Number(aktDate.substring(0, 4)) - Number(this.chd2Val);
          } else {
            tempDate = Number(aktDate.substring(0, 4)) - Number(3);
          }
          if (this.chd2Val != "" && this.chd2Val < 2) {
            infages += tempDate + aktDate.substring(4).replace(/-/g, "");
            infages += ",";
          } else {
            chdages += tempDate + aktDate.substring(4).replace(/-/g, "");
            chdages += ",";
          }
          if (chno > 2) {
            if (this.chd3Val != "") {
              tempDate = Number(aktDate.substring(0, 4)) - Number(this.chd3Val);
            } else {
              tempDate = Number(aktDate.substring(0, 4)) - Number(3);
            }
            if (this.chd3Val != "" && this.chd3Val < 2) {
              infages += tempDate + aktDate.substring(4).replace(/-/g, "");
              infages += ",";
            } else {
              chdages += tempDate + aktDate.substring(4).replace(/-/g, "");
              chdages += ",";
            }
            if (chno > 3) {
              if (this.chd4Val != "") {
                tempDate =
                  Number(aktDate.substring(0, 4)) - Number(this.chd4Val);
              } else {
                tempDate = Number(aktDate.substring(0, 4)) - Number(3);
              }
              if (this.chd4Val != "" && this.chd4Val < 2) {
                infages += tempDate + aktDate.substring(4).replace(/-/g, "");
                infages += ",";
              } else {
                chdages += tempDate + aktDate.substring(4).replace(/-/g, "");
                chdages += ",";
              }
            }
          }
        }
        if (this.chd > 0) {
          this.dparamsprice +=
            "&chda=" +
            chdages.substring(0, chdages.length - 1) +
            "&parChd=" +
            this.chd;
        }
        if (this.inf > 0) {
          this.dparamsprice +=
            "&infa=" +
            infages.substring(0, infages.length - 1) +
            "&parInf=" +
            this.inf;
        }
      }
    },
    checkAgainPrice(tOp) {
      // let's try another way
      // but first clean price details
      this.cleanPriceDetails();
      let thatt_ = this;
      if (tOp != "TUIZ" && tOp != "SNOW" && tOp != "SYKM") {
        this.checkMdsTotalPrice()
          .then((data) => {
            if (
              (data.Page.page.Status =
                "OK" &&
                data.Page.page.response.ofr &&
                data.Page.page.response.ofr.price &&
                !(data.Page.page.response.ofr.price instanceof Array))
            ) {
              thatt_.pricetotalVal = data.Page.page.response.ofr.price;
              thatt_.pricetotalCurr = data.Page.page.response.ofr.curr;
              thatt_.pricetotal =
                "" + thatt_.pricetotalVal + " " + thatt_.pricetotalCurr;
            } else {
              thatt_.pricetotalVal = -1;
              thatt_.pricetotal = "nieznana";
              thatt_.pricetotalCurr = "";
            }
            thatt_.$root.$emit("update:pricetotal", thatt_.pricetotal);
            thatt_.priceLoading = false;
            thatt_.searcherLoading = false;
          })
          .catch((e) => {
            thatt_.searcherLoading = false;
          });
      } else {
        thatt_.pricetotalVal = -1;
        thatt_.pricetotal = "nieznana";
        thatt_.pricetotalCurr = "";
        thatt_.$root.$emit("update:pricetotal", thatt_.pricetotal);
        thatt_.priceLoading = false;
        thatt_.searcherLoading = false;
      }
    },
    fillPriceDetails() {
      this.cherror = false;
      let that_ = this;
      this.arrAPersons = {};
      this.arrHashes = [];
      this.arrStrings = {};
      this.arrPersons.forEach(function (value, index) {
        if (!that_.cherror && value.date != null && value.date.length == 6) {
          let age = "19" + value.date.substring(4);
          let biezacyrok = that_.parseISO8601(that_.startDateVal);
          let d = new Date().getFullYear();
          if (biezacyrok) {
            d = biezacyrok.getFullYear();
          }
          age = Number(d) - Number(age);
          var who = "";
          if (age > 99) {
            if (age == 100 || age == 101) {
              who = "Niemowlę";
            } else {
              age = age - 100;
              if (age == 2 || age == 3 || age == 4)
                who = "Dziecko (" + age + " lata)";
              else who = "Dziecko (" + age + " lat)";
            }
          } else if (age < 16) {
            if (age == 2 || age == 3 || age == 4)
              who = "Dziecko (" + age + " lata)";
            else who = "Dziecko (" + age + " lat)";
          } else {
            who = "Dorosły";
          }
          let hash = that_.stringToHash(who);
          var objWho = that_.arrAPersons[hash];
          if (!objWho) {
            objWho = {
              counter: 0,
              price: 0,
            };
          }
          objWho.counter += 1;
          objWho.price = value.price;
          that_.arrAPersons[hash] = objWho;
          that_.arrStrings[hash] = who;
          if (!that_.arrHashes.includes(hash)) {
            that_.arrHashes.push(hash);
          }
        } else {
          cherror = true;
        }
      });
      this.searcherLoading = false;
      this.pricedetails = true;
    },
    parseISO8601(dateStringInRange) {
      var isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*$/,
        date = new Date(NaN),
        month,
        parts = isoExp.exec(dateStringInRange);

      if (parts) {
        month = +parts[2];
        date.setFullYear(parts[1], month - 1, parts[3]);
        if (month != date.getMonth() + 1) {
          date.setTime(NaN);
        }
      }
      return date;
    },
    stringToHash(value) {
      var hash = 0;
      if (value.length == 0) return hash;

      var i;
      for (i = 0; i < value.length; i++) {
        var char = value.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }
      if (hash < 0) {
        hash = hash * -1;
      }
      return hash;
    },
    getHashString(hash) {
      return this.arrStrings[hash];
    },
    cleanPriceDetails() {
      this.pricedetails = false;
      this.arrPersons = [];
      this.arrAPersons = {};
      this.arrHashes = [];
      this.arrStrings = {};
    },
    reloadData(
      firstRun,
      omitTermin,
      omitWyjazd,
      omitPobyt,
      omitWyzyw,
      omitAdt,
      omitChd,
      cleanURL
    ) {
      if (cleanURL) {
        // console.log("Reload data with CLEAN URL");
      } else {
        this.getQueryParams(
          firstRun,
          omitTermin,
          omitWyjazd,
          omitPobyt,
          omitWyzyw,
          omitAdt,
          omitChd
        );
      }
      this.getDropdownItems().then((data) => {
        //alert('Filtry:' + JSON.stringify(data.Page.page.Dropdowns.fdef));
        if (data.Page.page.Dropdowns && data.Page.page.Dropdowns.fdef) {
          this.fdata = data.Page.page.Dropdowns.fdef;
        } else {
          this.fdata = [];
        }
        if (data.Page.Tourops) {
          this.ftourops = data.Page.Tourops;
          let arr = [];
          let tp = this.getFiltryItems("ofr_tourOp");
          tp.forEach(function (value, index) {
            arr.push(value.id);
          });
        }
      });
      this.getOfferDetails()
        .then((data) => {
          let oferta = "";
          let exists = true;
          if (data.Page.page.response && data.Page.page.response.grp) {
            oferta = data.Page.page.response.grp;
          } else if (
            data.Page.page.responseAkt &&
            data.Page.page.responseAkt["count"] &&
            data.Page.page.responseAkt["count"] != 0
          ) {
            oferta = data.Page.page.responseAkt;
          } else {
            // console.log("ERROR. Oferta not found.");
            exists = false;
            this.validoffer = false;
            this.$root.$emit("update:validoffer", this.validoffer);
            this.searcherLoading = false;
          }
          if (exists) {
            this.validoffer = true;
            this.$root.$emit("update:validoffer", this.validoffer);
            this.kodId = oferta.ofr.id;
            this.tourOp = oferta.ofr.tourOp;
            this.ofr_type = oferta.ofr.type;
            this.ofr_typeVal = [];
            this.ofr_typeVal.push(this.getDojazd(this.ofr_type, true));
            this.minPax = oferta.ofr.obj.minPax;
            this.maxPax = oferta.ofr.obj.maxPax;
            this.minAdt = oferta.ofr.obj.minAdt;
            this.maxAdt = oferta.ofr.obj.maxAdt;
            // this.hotel = oferta.ofr.obj.name;
            this.ofrObjName = oferta.ofr.obj.name;
            this.$root.$emit("update:ofrObjName", this.ofrObjName);

            var htlCode = oferta.ofr.obj.code;
            var xCode = oferta.ofr.obj.xCode;
            var city = oferta.ofr.obj.xCity;
            var xCity = city !== "" ? city : CONFIG.panstwo_stolica;

            if (!this.firstGTM) {
              sendGTM(
                this.getPanstwoId(),
                this.tourOp,
                htlCode,
                xCode,
                xCity,
                this.ofrObjName
              );
              this.firstGTM = true;
            }

            this.fromDate = this.getFromDate(oferta.ofr.trp.startDate);
            this.$root.$emit(
              "update:fromDate",
              this.formatData(oferta.ofr.trp.startDate)
            );
            this.kierunek =
              oferta.ofr.obj.country +
              " / " +
              oferta.ofr.obj.region +
              " / " +
              oferta.ofr.obj.xCity;
            this.zakwaterowanie = oferta.ofr.obj.roomDesc;
            this.xServiceId = oferta.ofr.obj.xServiceId;
            if (oferta.ofr.obj.xAttributes) {
              this.hattr = oferta.ofr.obj.xAttributes;
              if (
                this.hattr != null &&
                this.hattr != "NaN" &&
                this.hattr.indexOf("x") != -1
              ) {
                var hex = this.hattr.split("x")[1];
                var hex2 = bigInt(hex, 16);
                var bin = hex2.toString(2);
                // console.log(bin);
                this.hattrs = bin.split("");
                this.hattrs.reverse();
                let hotelAttributes = this.hattrs;
                this.$root.$emit("update:hotelAttributes", hotelAttributes);
                //console.log([...this.hattrs]);
                //console.log("Attributes: " + this.hattrs);
              }
            }
            this.$root.$emit("update:hattrsVisible", true);
            if (
              oferta.ofr.obj.xLat &&
              oferta.ofr.obj.xLat != "" &&
              oferta.ofr.obj.xLong &&
              oferta.ofr.obj.xLong != ""
            ) {
              if (
                oferta.ofr.obj.xLat.indexOf("200.00") === -1 &&
                oferta.ofr.obj.xLong.indexOf("200.00") === -1
              ) {
                let latLongVals = [];

                latLongVals.push({
                  objName: oferta.ofr.obj.name,
                  lat: oferta.ofr.obj.xLat,
                  lng: oferta.ofr.obj.xLong,
                });
                this.$root.$emit("update:latLongVals", latLongVals);
              } else {
                // błędne współrzędne dla Mapy
                this.$root.$emit("update:geovalid", false);
              }
            }
            this.tstartDate = this.formatData(oferta.ofr.trp.startDate);
            this.tendDate = this.formatData(oferta.ofr.trp.rDepDate);
            this.dojazd = this.getDojazd(this.ofr_type, true);
            this.price = oferta.ofr.price;
            if (
              oferta.ofr.extra &&
              oferta.ofr.extra.priceHistory &&
              oferta.ofr.extra.priceHistory.max
            ) {
              this.maxprice = oferta.ofr.extra.priceHistory.max;
            }
            this.countryId = oferta.ofr.obj.xCountryId;
            if (!omitWyzyw) {
              this.xServiceIdVal = [];
              this.xServiceIdVal.push(
                this.getWyzywienie(Number(this.xServiceId))
              );
            }
            this.duration = oferta.ofr.trp.durationM;
            if (!omitPobyt) {
              this.durationVal = [];
              this.durationVal.push(this.duration);
            }
            this.startDate = oferta.ofr.trp.startDate;
            if (!omitTermin) {
              this.startDateVal = [];
              this.startDateVal.push(this.formatData(this.startDate));
            }
            // console.log("DONEEEEEEEEEE");
            this.depName = oferta.ofr.trp.depName;
            if (!omitWyjazd) {
              this.depNameVal = [];
              if (this.depName == "") {
                this.depName = "dowolny";
              }
              this.depNameVal.push(this.depName);
            }
            if (firstRun && !omitChd) {
              if (this.chd > 0) {
                //
              } else if (Number(this.minPax) > Number(this.maxAdt)) {
                this.chd = Number(this.minPax) - Number(this.maxAdt);
                this.chdVal = [];
                this.chdVal.push(this.chd);
              } else {
                this.chd = 0;
                this.chdVal.push(0);
              }
            }

            // offer type
            if (oferta.ofr.obj && oferta.ofr.obj.type) {
              this.offerType = oferta.ofr.obj.type;
              this.$root.$emit("update:offerType", this.offerType);
            }
            // region i city
            if (oferta.ofr.obj && oferta.ofr.obj.region) {
              this.region = oferta.ofr.obj.region;
              this.$root.$emit("update:region", this.region);
            }
            if (oferta.ofr.obj && oferta.ofr.obj.xCity) {
              this.xcity = oferta.ofr.obj.xCity;
              this.$root.$emit("update:xcity", this.xcity);
            }
            if (
              oferta.ofr.obj &&
              oferta.ofr.obj.city &&
              !(oferta.ofr.obj.city instanceof Array)
            ) {
              this.city = oferta.ofr.obj.city;
              this.$root.$emit("update:city", this.city);
            }

            let tourOp = oferta.ofr.tourOp;
            this.$root.$emit("update:tourOp", tourOp);
            let code = oferta.ofr.obj.code;
            this.$root.$emit("update:code", code);
            let category = oferta.ofr.obj.category;
            this.$root.$emit("update:category", category);
            let tripDetails = oferta.ofr.trp;
            this.$root.$emit("update:tripDetails", tripDetails);

            this.setPriceParams();
            this.directlink =
              "xCode=" +
              oferta.ofr.obj.xCode +
              "&tourOp=" +
              oferta.ofr.tourOp +
              "&htlCode=" +
              oferta.ofr.obj.code +
              "&kodId=" +
              oferta.ofr.id +
              "&termin=" +
              this.formatData(oferta.ofr.trp.depDate) +
              "&date=" +
              this.formatData(oferta.ofr.trp.depDate) +
              "&pobyt=" +
              oferta.ofr.trp.durationM +
              "&wyjazd=" +
              WYJAZD.wyjazdToLower(oferta.ofr.trp.depName) +
              "&wyz=" +
              this.getWyzywienieVal(Number(oferta.ofr.obj.xServiceId)) +
              "&adt=" +
              this.adt +
              "&" +
              this.calculateChage();
            let directlink = this.directlink;
            this.$root.$emit("update:directlink", directlink);
            this.dparamstotprice = "x=1&totp=1&" + this.dparamsprice;
            let history = false;
            if (
              oferta.ofr.extra === undefined ||
              oferta.ofr.extra instanceof Array
            ) {
              history = false;
              let price = oferta.ofr.price;
              console.log("PRICE:" + price);
              this.$root.$emit("update:price", price);
              this.$root.$emit("update:discount", 0);
            } else if (
              oferta.ofr.extra.priceHistory &&
              oferta.ofr.extra.priceHistory.max
            ) {
              history = true;
              let maxprice = oferta.ofr.extra.priceHistory.max;
              let price = oferta.ofr.price;
              if (maxprice != price) {
                let discount = Math.floor(
                  this.getDiscount(Number(price), Number(maxprice))
                );
                // console.log("DISCOUNT:" + discount);
                this.$root.$emit("update:price", price);
                this.$root.$emit("update:oldprice", maxprice);
                this.$root.$emit("update:discount", discount);
                this.discount = discount;
              } else {
                // console.log("PRICE:" + price);
                this.$root.$emit("update:price", price);
                this.$root.$emit("update:discount", 0);
              }
            }
            this.getOfferOptions().then((data) => {
              //console.log('OfferOptions:' + JSON.stringify(data.Page.offeroptions.response));
              if (data.Page.offeroptions.response) {
                this.foptions = data.Page.offeroptions.response;
                if (this.foptions.page && this.foptions.page.HoteleURL) {
                  if (this.foptions.page.HoteleURL instanceof Array) {
                    if (this.foptions.page.HoteleURL[0].row instanceof Object) {
                      this.hlocid =
                        this.foptions.page.HoteleURL[0].row.naszlocid;
                      this.$root.$emit("update:hlocid", this.hlocid);
                    }
                  }
                }
              } else {
                this.foptions = [];
              }
            });
            this.$root.$emit("update:pricevisible", true);
            let that_ = this;
            this.checkMdsPrice()
              .then((data) => {
                if (
                  data.Page.page.Status == "OK" &&
                  data.Page.page.response &&
                  (data.Page.page.response.merlin_offer_status == "OK" ||
                    data.Page.page.response.merlin_offer_status == "RQ")
                ) {
                  if (
                    data.Page.page.response.pricetotal &&
                    data.Page.page.response.pricetotal.price &&
                    !(data.Page.page.response.pricetotal.price instanceof Array)
                  ) {
                    that_.pricetotalVal =
                      data.Page.page.response.pricetotal.price;
                    that_.pricetotalCurr =
                      data.Page.page.response.pricetotal.curr;
                    that_.pricetotal =
                      "" + that_.pricetotalVal + " " + that_.pricetotalCurr;
                    that_.$root.$emit("update:pricetotal", that_.pricetotal);
                    that_.priceLoading = false;
                    if (data.Page.page.response.persons) {
                      // console.log("Price details found.");
                      that_.arrPersons = data.Page.page.response.persons;
                      that_.fillPriceDetails();
                    } else {
                      that_.cleanPriceDetails();
                    }
                  } else {
                    // let's try another way
                    that_.checkAgainPrice(that_.tourOp);
                  }
                } else {
                  // let's try another way
                  that_.checkAgainPrice(that_.tourOp);
                }
              })
              .catch((e) => {
                console.log("Timeout occurred. Sorry Willis.");
                // let's give it a last try
                that_.checkAgainPrice(that_.tourOp);
              });
          } else {
            this.$root.$emit("update:pricevisible", false);
          }
        })
        .catch((e) => {
          console.log("Whadda fuck:" + e);
        });
    },
  },
  mounted() {
    var path = this.$route.path;
    var routepars = this.$route.query;
    var that = this;
    T1VarLoader.loadMissingURLParams(path).then((data) => {
      var xmlObj = jQuery(data);
      var offer_count = xmlObj.find("count").text();
      if (offer_count > 0 || path.includes("/hotele/hotel.xml")) {
        that.$cheapest_tourOp = xmlObj.find("ofr").attr("tourOp");
        that.$cheapest_kodId = xmlObj.find("ofr").attr("id");
        that.$cheapest_xCode = xmlObj.find("obj").attr("xCode");
        that.$cheapest_htlCode = xmlObj.find("obj").attr("code");
        that.$cheapest_adt = xmlObj.find("obj").attr("minAdt");
        if (routepars["kodId"]) {
          that.reloadData(
            true,
            false,
            false,
            false,
            false,
            false,
            false,
            false
          );
        } else {
          // console.log("CLEAN URL");
          that.xCode = that.$cheapest_xCode;
          that.dparams += "&xCode=" + that.xCode;

          that.tourOp = that.$cheapest_tourOp;
          that.dparams += "&tourOp=" + that.tourOp;
          this.tourOpVal = [];
          this.tourOpVal.push(that.tourOp);

          that.htlCode = that.$cheapest_htlCode;
          that.dparams += "&htlCode=" + that.htlCode;

          that.adt = Number(that.$cheapest_adt);
          that.dparams += "&adt=" + that.$cheapest_adt;
          that.adtVal = [];
          that.adtVal.push(Number(that.$cheapest_adt));

          that.kodId = that.$cheapest_kodId;
          that.dparamsoptions += that.dparams.substring(12);
          that.dparams += "&kodId=" + that.kodId;

          that.dparamsoferty = "kodId=" + this.kodId;
          that.setPriceParams();
          that.dparamstotprice = "x=1&totp=1&" + that.dparamsprice;

          this.reloadData(true, false, false, false, false, false, false, true);
        }
      } else {
        // console.log("What a terrible case Mr. Jenkins.. I give up. No offers.");
        that.$root.$emit("update:soyonara", "sepuku");
      }
    });
  },
  components: {
    T1VarLoader,
  },
};

function sendGTM(country, tourOp, htlCode, xCode, city, hname) {
  var tOp = "" + tourOp + "";
  var hCode = "" + htlCode + "";
  var xKod = "" + xCode + "";
  var xCity = "" + city + "";
  var xCountry = "" + country + "";
  var xName = "" + hname + "";

  console.log("About dataLayer push data to GTM...");
  dataLayer.push({
    transactionOp: tOp,
    transactionHCode: hCode,
    transactionXKod: xKod,
    transactionXCity: xCity,
    transactionXName: xName,
    transactionXCountry: xCountry,
  });
  console.log("dataLayer data sent");
}

function scrollToForm() {
  var targetOffset = $(".order-form").offset().top;
  $("html, body").animate({ scrollTop: targetOffset }, 400);
}
</script>

<style lang="scss" scoped>
@import "@/components/T1Searchers/T1OfferConfigSearcherStyles";
</style>
